import React, {Fragment, useState, useEffect, useContext} from "react";

import './TeamMembersTab.scss';
import useModalAddTeamMember from "root/Modals/AddTeamMember/useModalAddTeamMember";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import TeamMemberTable from "root/Tables/TeamMemberTable";
import {getTeamMembers, getUsersConnectedToChildrenInTeam, removeUserFromTeam} from "root/DataFunctions/TeamDataFns";
import {UserRights, UserTypeFilters, UserTypes} from "root/DataFunctions/Constants";
// import bootbox from "bootbox";
import {useSetRecoilState} from "recoil";
import {teamNameAtom} from "root/recoil/teamName";
import {getTeamDetails} from "root/DataFunctions/TeamDataFns";
import {useParams} from "react-router";
import useModalAddUser from "root/Modals/AddUser/useModalAddUser";
import useModalUpdateChild from "root/Modals/UpdateChildDetails/useModalUpdateChild";
import {inviteAgain, reinstateUser, suspendUser} from "root/DataFunctions/UserDataFns";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import useModalManageRights from "root/Modals/ManageRights/useModalManageRights";
import useModalChangePassword from "root/Modals/ChangePassword/useModalChangePassword";

import GlobalContext from "root/contexts/GlobalContext";

const TeamMembersTab = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});
    const globals = useContext(GlobalContext);

    const onSaveComplete = (result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    }

    const [renderAddTeamMemberModal, showAddTeamMemberModal] = useModalAddTeamMember ( onSaveComplete ) ;
    const [renderAddChildModal, showAddChildModal] = useModalUpdateChild( onSaveComplete );

    const [renderManageRightsModal, showManageRightsModal] = useModalManageRights((result) =>
    {
        // do nothing
    })

    const [renderChangePasswordModal, showChangePasswordModal] = useModalChangePassword(null, (result) =>
    {
        // do nothing
    })

    const [renderAddUserModal, showAddUserModal] = useModalAddUser((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const user_filter_type = queryParams.user_type === undefined ? UserTypeFilters.STAFF : queryParams.user_type;

    let { team_id } = useParams();

    // Not sure why we don't need to use encodeuricomponent here but it works without.......
    const enc_team_id = team_id === undefined ? props.team_id : team_id ;

    //Get child's data and set the global child name used by the various body header
    const setTeamName = useSetRecoilState(teamNameAtom);

    useEffect(() => {
        getData();
    }, [team_id, user_filter_type]);

    useEffect(() => {
        getTeamData( enc_team_id );
    }, [enc_team_id]);

    const typeFromFilter = (userTypeFilter) =>
    {
        const map = {
            [UserTypeFilters.FOSTER_CARERS]: UserTypes.FOSTER_PARENT,
            [UserTypeFilters.PROFESSIONALS]: UserTypes.PROFESSIONAL,
            [UserTypeFilters.OTHERS]: UserTypes.OTHER,
            [UserTypeFilters.FOREVER_PARENTS]: UserTypes.FOREVER_PARENT,
            [UserTypeFilters.CONNECTED_CARERS]: UserTypes.CONNECTED_CARER,
            [UserTypeFilters.BIRTH_PARENTS]: UserTypes.BIRTH_PARENT,
        }

        return map[userTypeFilter] === undefined ? null : map[userTypeFilter];
    }

    const getData = () =>
    {
        switch ( user_filter_type)
        {
            case UserTypeFilters.STAFF :
                getTeamMembers(enc_team_id, 'staff', (response) =>
                {
                    setData({isLoading: false, data: getDataFromResponse(response)});
                });
                break;
            case UserTypeFilters.CHILDREN :
                getTeamMembers(enc_team_id, 'children', (response) =>
                {
                    setData({isLoading: false, data: getDataFromResponse(response)});
                });
                break;
            default:
                const type = typeFromFilter(user_filter_type);

                if (type !== null)
                {
                    getUsersConnectedToChildrenInTeam(enc_team_id, type, (response) =>
                    {
                        setData({isLoading: false, data: getDataFromResponse(response)});
                    });
                }
                break ;
        }
    };

    const getTeamData = (param_team_id) =>
    {
        getTeamDetails(param_team_id, (response) =>
            {
                let teamData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setTeamName({ name: teamData.team_name, filter: user_filter_type } );
            });
    }

    const removeTeamMember = (user_id, loc_team_id) =>
    {
        bootbox.confirm({
            size: "small",
            message: "Are you sure you want to remove this user from this team?",
            callback: (result =>
            {
                if (result)
                {
                    removeUserFromTeam(loc_team_id, user_id, (response) =>
                    {
                        getData();
                    });
                }
            })
        })
    }

    const clickHandler = ( mode, user_id, userTypeId, loc_team_id, name ) =>
    {
        switch ( mode)
        {
            case 'remove' :
                removeTeamMember(user_id, loc_team_id);
                break;
            case 'create' :
                showAddTeamMemberModal(loc_team_id, user_filter_type);
                break;
            case 'edit':
                showAddUserModal(user_id, mode, userTypeId, false);
                break;
            case 'view':
                if (userTypeId === UserTypes.CHILD)
                {
                    showAddChildModal(user_id, mode);
                }
                else
                {
                    showAddUserModal(user_id, mode, userTypeId, false);
                }
                break ;

            case 'suspend' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to suspend this user?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            suspendUser(user_id, (response) =>
                            {
                                getData();
                            });
                        }
                    })
                })
                break;

            case 'activate' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to activate this user?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            reinstateUser(user_id, (response) =>
                            {
                                getData();
                            });
                        }
                    })
                })
                break;

            case 'invite' :
                inviteAgain(user_id, (response) =>
                {
                    bootbox.alert({
                        size: "small",
                        message: "A new invite has been sent to this user.",
                        callback: function ()
                        {
                            getData();
                        }
                    })
                });
                break;

            case 'password' :
                showChangePasswordModal(user_id);
                break;

            case 'rights' :
                showManageRightsModal(user_id, name);
                break;
        }
    }

    const btnTitle = () =>
    {
        if ( user_filter_type === UserTypeFilters.STAFF )
        {
            return "Add Staff Member to Team" ;
        }
        else if ( user_filter_type === UserTypeFilters.CHILDREN )
        {
            return "Assign Child to Team" ;
        }
    }

    return (
        <Fragment>
            <div className="team_members-body">
                <TeamMemberTable team_id={enc_team_id} user_filter_type={user_filter_type} loading={data.isLoading} data={data.data} clickHandler={clickHandler}/>
                { (user_filter_type === UserTypeFilters.STAFF || user_filter_type === UserTypeFilters.CHILDREN) && <section>
                    <ActionButton icon='icon-add' onClick={() => clickHandler( 'create', null, null, enc_team_id)} title={btnTitle()}/>
                </section> }
            </div>

            {renderAddTeamMemberModal(props)}
            {renderAddUserModal(props)}
            {renderAddChildModal(props)}
            {renderManageRightsModal(props)}
            {renderChangePasswordModal(props)}

        </Fragment>
    )
}

TeamMembersTab.defaultProps = {};

export default TeamMembersTab;

